const moment = require("moment");
const utils = require("Sources/utils/utils");

module.exports = class SubscriptionModule
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.key = options.key;
    this.name = options.name;
    this.settings = options["settings"];
  };
};



// WEBPACK FOOTER //
// ./app/js/models/subscription-module.js